import "can/component/";
import "can/view/stache/";


can.Component.extend({
    tag: "theme-changer",
    template: can.view( "src/components/theme-changer/theme-changer.stache" )
});
